import {
    Box,
    Heading,
    HStack,
    Text,
    VStack,
    Flex,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Button,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { InvoiceSection } from './dashboard/components/DashboardStyles';
import { backbtn } from './dashboard/components/Icons';
import { useDispatch, useSelector } from 'react-redux';
import { place_order } from '../redux/actions/productActions';
import toast from 'react-hot-toast';
import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';

const Invoices = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const productReducer = useSelector((state) => state.productReducer);
    const { cartItems, billing_info, quoteId } = productReducer;

    const orderObject = useMemo(() => {
        return {
            quoteId,
            data: {
                paymentMethod: {
                    method: 'cashondelivery',
                },
            },
        };
    }, [quoteId]);

    const placeOrder = () => {
        toast.promise(
            dispatch(place_order(orderObject)),
            {
                loading: 'Placing...',
                success: <b> Order Placed</b>,
                error: <b>Could not Place Order.</b>,
            },
            { position: 'top-right' },
        );
    };

    let invoiceObj = {
        issueDate: 'Oct 22 2022',
        invoiceId: '#001234',
        orderId: '21344535',
    };

    const total = cartItems?.items.reduce((a, b) => a + Number(b.price * b?.qty), 0);

    return (
        <InvoiceSection>
            <HStack justifyContent="space-between" mr="9rem" mb="0.4rem">
                <div></div>
                <HStack gap="12px" mb={{ lg: '2rem', base: '0' }}>
                    <Text
                        fontSize="11px"
                        textDecor="underline"
                        lineHeight="16px"
                        cursor="pointer"
                        onClick={() => {
                            navigate('/dashboard', { replace: false });
                        }}>
                        Home
                    </Text>
                    <Text
                        fontSize="11px"
                        textDecor="underline"
                        lineHeight="16px"
                        cursor="pointer"
                        onClick={() => {
                            navigate('/dashboard/cart', { replace: false });
                        }}>
                        Cart
                    </Text>
                    <Text
                        fontSize="11px"
                        textDecor="underline"
                        lineHeight="16px"
                        cursor="pointer"
                        onClick={() => {
                            navigate('/dashboard/delivery', { replace: false });
                        }}>
                        Delivery
                    </Text>
                </HStack>
            </HStack>
            <HStack
                justify="space-between"
                display={{ base: 'flex', lg: 'none', sm: 'flex' }}
                alignItems="center"
                mt="27px"
                w="900vw"
                mx="auto">
                <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                <div className="menuSection"></div>
                <div></div>
            </HStack>
            <Box
                mx="auto"
                w={{ base: '1400vw', lg: '80%' }}
                bg={{ base: 'none', lg: 'none' }}
                p={{ base: '0', lg: '15px 30px' }}
                boxShadow={{ base: 'none', lg: '0px 4px 33px rgba(0, 0, 0, 0.03)' }}>
                <Heading color="#090A0A" lineHeight="36px" fontSize="32px" mt="20px" mb="5px">
                    Invoice
                </Heading>

                <HStack my="20px" justify="space-between" px="0.3rem">
                    <Flex>
                        <Box fontWeight="900">
                            <Text fontSize="14px">IssueDate: {invoiceObj.issueDate}</Text>
                            <Text fontSize="14px">Invoice: {invoiceObj.invoiceId}</Text>
                            <Text fontSize="14px">OrderId: {invoiceObj.orderId}</Text>
                        </Box>
                    </Flex>
                    <Box textAlign="right">
                        <Text fontSize="24" fontWeight="600">
                            Obana Store One
                        </Text>
                        <Text fontSize="14px" float="left" p="0.3rem" color="#878787">
                            09039495969
                        </Text>
                    </Box>
                </HStack>

                <VStack w="full" pt="50px" mb="1.7rem">
                    <HStack w="full">
                        <Text fontWeight="500">BILLED TO</Text>
                    </HStack>
                    <HStack w="full">
                        <Text fontSize="14" fontWeight="700">
                            {billing_info?.addressInformation?.shippingAddress?.firstname}
                        </Text>
                    </HStack>
                    <HStack w="full">
                        <Text fontSize="16" fontWeight="500">
                            {billing_info?.addressInformation?.shippingAddress?.street[0]}
                        </Text>
                    </HStack>
                    <HStack w="full">
                        <Text fontSize="16" fontWeight="500">
                            {billing_info?.addressInformation?.shippingAddress?.telephone}
                        </Text>
                    </HStack>
                </VStack>
                <TableContainer>
                    <Table size="sm" lineHeight="2.5rem">
                        <Thead>
                            <Tr>
                                <Th>#</Th>
                                <Th>Item Description</Th>
                                <Th>Unit Price (Per Pack)</Th>
                                <Th>Qty</Th>
                                <Th>Subtotal</Th>
                            </Tr>
                        </Thead>
                        {cartItems?.items?.map(function (item, index) {
                            return (
                                <Tbody key={item.id}>
                                    <Tr>
                                        <Td>{index + 1}</Td>
                                        <Td fontWeight="700">{item.name}</Td>
                                        <Td>
                                            {new Intl.NumberFormat('en-NG', {
                                                style: 'currency',
                                                currency: 'NGN',
                                            }).format(item.price)}
                                        </Td>
                                        <Td>{item.qty}</Td>
                                        <Td>
                                            {new Intl.NumberFormat('en-NG', {
                                                style: 'currency',
                                                currency: 'NGN',
                                            }).format(item.price * item.qty)}
                                        </Td>
                                    </Tr>
                                </Tbody>
                            );
                        })}
                    </Table>
                </TableContainer>

                <Flex flexDirection="row" fontSize="12" p="7" pt="3rem" pr="0">
                    <VStack w="full">
                        <HStack w="full">
                            <Heading fontSize="12" color="#C1C1C1">
                                Payment Details
                            </Heading>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="500">Account Holder</Text>{' '}
                            <Text>
                                {billing_info?.addressInformation?.shippingAddress?.firstnam}
                            </Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="500">Account Number</Text> <Text>000000000000</Text>
                        </HStack>

                        <HStack w="full">
                            <Text fontWeight="500">Bank Name</Text> <Text>Access Bank</Text>
                        </HStack>
                    </VStack>
                    <VStack w="full">
                        <HStack w="full">
                            <Heading fontSize="12" color="#C1C1C1">
                                Totals
                            </Heading>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="600" fontSize="19">
                                Discount
                            </Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="600" fontSize="19">
                                Tax 7.5%
                            </Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="700" fontSize="23">
                                Total
                            </Text>
                        </HStack>
                    </VStack>
                    <VStack
                        w="full"
                        textAlign="right"
                        alignContent="end"
                        justifyContent="end"
                        alignSelf="end">
                        <HStack w="full">
                            <Text fontWeight="700" fontSize="16"></Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="700" fontSize="16">
                                {'-'}
                                {new Intl.NumberFormat('en-NG', {
                                    style: 'currency',
                                    currency: 'NGN',
                                }).format(0)}
                            </Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="700" fontSize="16">
                                {new Intl.NumberFormat('en-NG', {
                                    style: 'currency',
                                    currency: 'NGN',
                                }).format(0.075 * total)}
                            </Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="700" fontSize="23">
                                NGN
                            </Text>
                        </HStack>
                        <HStack w="full">
                            <Text fontWeight="700" fontSize="23">
                                {new Intl.NumberFormat('en-NG', {
                                    style: 'currency',
                                    currency: 'NGN',
                                }).format(total)}
                            </Text>
                        </HStack>
                    </VStack>
                </Flex>
            </Box>
            <VStack mt="20px">
                <Button
                    w="45%"
                    color="#F5F5F5"
                    bg="#1b3b5f"
                    mt="15px"
                    fontWeight="400"
                    borderRadius="48px"
                    outline="none"
                    onClick={async () => {
                        await placeOrder();
                        await navigate('/dashboard', { replace: 'true' });
                    }}>
                    Place Order
                </Button>
            </VStack>
        </InvoiceSection>
    );
};

export default Invoices;
